module.exports = __webpack_public_path__ + "assets/img/37_1529.fadf74ab.jpg";